import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type ErrorTeamProps = {
  title: string | undefined;
  description: string | undefined;
  isSearchError?: boolean;
};

const ErrorTeam: FC<ErrorTeamProps> = ({ title, description, isSearchError }) => {
  const { t } = useTranslation(['beneficiaries', 'errorNoTeam']);

  return (
    <div className="no-team-container">
      <div className="center">
        <div className="img-baggage-container">
          <img
            alt="bagage"
            className="baggage-img"
            src="https://smiles-mkt.s3.amazonaws.com/cobranded-api-bb/baggage.png"
          />
        </div>
        <div className="no-team-col-container">
          <div className="no-team-title-container">
            <h3 className="no-team-title">{title}</h3>
          </div>
          <div className="no-team-description-container">
            <p className="no-team-description">{description}</p>
          </div>
          {isSearchError && (
            <a
              href="https://voebiz.smiles.com.br/atendimento/formulario"
              target="_blank"
              rel="noopener noreferrer"
              className="redirect-anchor"
            >
              {t('link', { ns: 'errorNoSearch' })}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorTeam;
